module.exports = __webpack_public_path__ + "static/banner-mobile-30be9bcd4c887a1cf96caa19abac1263.png";